import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M7.94 4.33901L11.422 10.369L5.482 20.662L2 14.633L7.94 4.33901ZM10.116 14.633H22L18.518 20.662H6.635L10.116 14.633ZM14.459 13.633L8.518 3.33801H15.482L21.422 13.633H14.46H14.459Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Drive"
);
